import { useQuery } from '@tanstack/react-query';
import { fetchAttachableUsers } from '../services/security-groups';

interface Params {
  groupId: string;
  search?: string;
  page?: number;
  per_page?: number;
  /** Additional enabled guard. Defaults to true. Useful for deferring the
   *  all-candidates (per_page=200) query until the attachAll checkbox is ticked. */
  enabled?: boolean;
}

export function useGroupAttachableUsersQuery({ groupId, search, page = 1, per_page = 25, enabled = true }: Params) {
  return useQuery({
    queryKey: ['security-group', groupId, 'attachable-users', { search, page, per_page }],
    queryFn: () => fetchAttachableUsers(groupId, { search, page, per_page }),
    enabled: !!groupId && enabled,
  });
}
